import _ from "lodash";

const taskStatus = [
  {
    id: 1,
    text: "Not Started",
    color: "red",
  },
  {
    id: 2,
    text: "In Progress",
    color: "orange",
  },
  {
    id: 3,
    text: "On Hold",
    color: "blue",
  },
  {
    id: 4,
    text: "Completed",
    color: "green",
  },
];

const getTaskStatusById = (id: number): string => {
  const status = _.find(taskStatus, stat => stat.id == id);
  if (!status) return "";
  return status.text;
};

const getTaskStatusIdByText = (text: string): number => {
  const status = _.find(
    taskStatus,
    stat => stat.text.toLowerCase() === text.toLowerCase(),
  );
  if (!status) return 0;
  return status.id;
};

const getTaskStatusColor = (id: number): string => {
  const status = _.find(taskStatus, stat => stat.id === id);
  if (!status) return "grey";
  return status.color;
};

export {
  taskStatus,
  getTaskStatusById,
  getTaskStatusIdByText,
  getTaskStatusColor,
};
